import { useCallback, useMemo } from "react";

import { useFormContext } from "react-hook-form";

import WorkOrderDepartment from "./WorkOrderDepartment";

import { SECTION_FORMS } from "../../tables/RoutingTable";
import { useHubSnackBar } from "../../hooks";
import { buildRouteOps } from "./helper";
import { ROUTING_SECTIONS } from "../../constants";

import { StyledContainer, StyledCardStack } from "./styles";

const findDepartmentDetails = (departmentId) =>
  ROUTING_SECTIONS.find((d) => d.departmentId === departmentId);

// Position in the canonical render order. Unknown departments sink to the end.
const orderRank = (departmentId) => {
  const i = ROUTING_SECTIONS.findIndex((d) => d.departmentId === departmentId);
  return i < 0 ? Number.MAX_SAFE_INTEGER : i;
};

export const WorkOrderInstructions = ({
  instructions = [],
  partInstructions = [],
  partId,
  locationId,
}) => {
  const { getValues, setValue } = useFormContext();
  const { addSnackbarError } = useHubSnackBar();

  const getRouteOps = useCallback(
    (instructionIdx) =>
      buildRouteOps({
        instructionIdx,
        getValues,
        setValue,
        addSnackbarError,
      }),
    [addSnackbarError, getValues, setValue],
  );

  const sectionForms = useMemo(
    () =>
      (instructions || [])
        .map((instruction, idx) => {
          const Form = SECTION_FORMS[instruction.departmentId];
          const section = findDepartmentDetails(instruction.departmentId);
          const partInstruction = partInstructions?.find(
            (pi) => pi.departmentId === instruction.departmentId,
          );
          return { Form, section, idx, instruction, partInstruction };
        })
        .filter(({ section }) => !!section)
        .sort(
          (a, b) =>
            orderRank(a.instruction.departmentId) -
            orderRank(b.instruction.departmentId),
        ),
    [instructions],
  );

  return (
    <StyledContainer>
      <StyledCardStack>
        {sectionForms.map(
          ({ Form, section, idx, instruction, partInstruction }) => (
            <WorkOrderDepartment
              key={section.key}
              label={section.label}
              sectionKey={section.key}
              isSelected
            >
              <Form
                basePath={`instructions.${idx}`}
                defaults={instruction}
                partInstruction={partInstruction}
                routeOps={getRouteOps(idx)}
                partId={partId}
                locationId={locationId}
              />
            </WorkOrderDepartment>
          ),
        )}
      </StyledCardStack>
    </StyledContainer>
  );
};

export default WorkOrderInstructions;
